import { Document, Font, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import dayjs from 'dayjs';
import { FC } from 'react';

Font.register({
  family: 'Roboto',
  src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf',
});

const styles = StyleSheet.create({
  page: {
    backgroundColor: '#FFFFFF',
    fontFamily: 'Roboto',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '38px',
    padding: '24px 15px',
  },
  image: {
    width: 80,
  },
  id: {
    fontSize: 18,
    fontWeight: 'medium',
  },
  rowWrap: {
    width: '100%',
    flexDirection: 'column',
    gap: 12,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: 5,
  },
  label: {
    fontSize: 12,
    fontWeight: 'thin',
  },
  value: {
    fontSize: 12,
    fontWeight: 500,
  },
  dataWrap: {
    flexDirection: 'column',
    gap: 4,
  },
});

interface IProps {
  bitrixId?: string;
  targetDate?: string;
  bitrixOrderData?: string;
  source?: string;
  deliveryType?: string;
}

const Receipt: FC<IProps> = ({ bitrixId, targetDate, bitrixOrderData, source, deliveryType }) => {
  const data = bitrixOrderData
    ?.replace(/\[\/b\]/g, '')
    .replace(/\[b\]/g, '')
    .split('_');

  return (
    <Document>
      <Page
        style={styles.page}
        size={{ height: data?.length ? 300 + data.length * 24 : 240, width: 240 }}
      >
        <Image
          style={styles.image}
          src="data:image/png;base64,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"
        />

        <View style={styles.rowWrap}>
          <View style={styles.row}>
            <Text style={styles.label}>ID заказа:</Text>
            <Text style={styles.value}>{bitrixId || '-'}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Дата забора:</Text>
            <Text style={styles.value}>{dayjs(targetDate).format('DD / MM / YYYY - HH:mm')}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Источник:</Text>
            <Text style={styles.value}>{source || '-'}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Тип доставки:</Text>
            <Text style={styles.value}>{deliveryType || '-'}</Text>
          </View>
          <View style={styles.dataWrap}>
            <Text style={styles.label}>Состав заказа:</Text>
            {data?.map((line, i) => (
              <Text key={i} style={styles.value}>
                {line}
                <br />
              </Text>
            )) || '-'}
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default Receipt;
